import React from 'react';
import RenderIf from 'components/RenderIf/RenderIf';
import { UNIT_TYPE_LABELS, UNIT_TYPES } from 'views/Deals/constants';
import { useAttributeSuggested } from 'components/DealForm/hooks/useSuggestedAttribute';
import { DefaultAttributes } from '../../types';
import DefaultAttributeInput from '../DefaultAttributeInput';

interface UnitsSectionProps {
    showSuggestedOnly: boolean;
}

const UnitsSection: React.FC<UnitsSectionProps> = ({
    showSuggestedOnly,
}) => {
    const { shouldRender } = useAttributeSuggested({
        attribute: DefaultAttributes.UNITS,
        showSuggestedOnly,
    });

    return (
        <RenderIf isTrue={shouldRender}>
            <div className="NSCard--level-3 mt-2 py-2 px-3 rounded">
                <div className="text-dark" data-testid="units-section-title">Units</div>
                <div className="CreateDeal__form__divider_muted mt-1 mb-2" />
                <div className="d-flex flex-wrap">
                    <DefaultAttributeInput
                        label={UNIT_TYPE_LABELS[UNIT_TYPES.GROSS_BUILD_SF]}
                        name={UNIT_TYPES.GROSS_BUILD_SF}
                        type="number"
                        placeholder="Enter value"
                        attribute={DefaultAttributes.UNITS}
                        showSuggestedOnly={showSuggestedOnly}
                        className="w-50 pr-2 mb-2"
                    />
                    <DefaultAttributeInput
                        label={UNIT_TYPE_LABELS[UNIT_TYPES.RENTABLE_SF]}
                        name={UNIT_TYPES.RENTABLE_SF}
                        type="number"
                        placeholder="Enter value"
                        attribute={DefaultAttributes.UNITS}
                        showSuggestedOnly={showSuggestedOnly}
                        className="w-50 pl-2 mb-2"
                    />
                    <DefaultAttributeInput
                        label={UNIT_TYPE_LABELS[UNIT_TYPES.ACRES]}
                        name={UNIT_TYPES.ACRES}
                        type="number"
                        placeholder="Enter value"
                        attribute={DefaultAttributes.UNITS}
                        showSuggestedOnly={showSuggestedOnly}
                        className="w-50 pr-2 mb-2"
                    />
                    <DefaultAttributeInput
                        label={UNIT_TYPE_LABELS[UNIT_TYPES.RESIDENTIAL_UNITS]}
                        name={UNIT_TYPES.RESIDENTIAL_UNITS}
                        type="number"
                        placeholder="Enter value"
                        attribute={DefaultAttributes.UNITS}
                        showSuggestedOnly={showSuggestedOnly}
                        className="w-50 pl-2 mb-2"
                    />
                    <DefaultAttributeInput
                        label={UNIT_TYPE_LABELS[UNIT_TYPES.LOTS]}
                        name={UNIT_TYPES.LOTS}
                        type="number"
                        placeholder="Enter value"
                        attribute={DefaultAttributes.UNITS}
                        showSuggestedOnly={showSuggestedOnly}
                        className="w-50 pr-2 mb-2"
                    />
                    <DefaultAttributeInput
                        label={UNIT_TYPE_LABELS[UNIT_TYPES.BEDS]}
                        name={UNIT_TYPES.BEDS}
                        type="number"
                        placeholder="Enter value"
                        attribute={DefaultAttributes.UNITS}
                        showSuggestedOnly={showSuggestedOnly}
                        className="w-50 pl-2 mb-2"
                    />
                    <DefaultAttributeInput
                        label={UNIT_TYPE_LABELS[UNIT_TYPES.MEGAWATTS]}
                        name={UNIT_TYPES.MEGAWATTS}
                        type="number"
                        placeholder="Enter value"
                        attribute={DefaultAttributes.UNITS}
                        showSuggestedOnly={showSuggestedOnly}
                        className="w-50 pr-2"
                    />
                </div>
            </div>
        </RenderIf>
    );
};

export default UnitsSection;
